import { Image } from '@chakra-ui/react';
import React from 'react';

import emptyStateImage from './empty-state.svg';
import emptyStateGrayscale from './empty-state-grayscale.svg';
import emptyStateGrayscale2 from './empty-state-grayscale-2.svg';
import emptyStateNotFound from './empty-state-not-found.svg';
import errorStateImage from './error-state.svg';
import errorState401Image from './error-state-401.svg';
import errorState404Image from './error-state-404.svg';
import errorState404GrayscaleImage from './error-state-404-grayscale.svg';
import errorState500Image from './error-state-500.svg';
import errorStateNetworkImage from './error-state-network.svg';
import dashboardImage from './dashboard.svg';
import noResultSearch from './noResultSearch.svg';
import searchEmptyState from './search-empty-state.svg';
import confirmationState from './confirmation-state.svg';
import confirmationState2 from './confirmation-state-2.svg';
import processingState from './processing-state.svg';
import emptyStateSellout from './empty-state-sellout.svg';

export const EmptyStateImage = () => <Image src={emptyStateImage} />;
export const EmptyStateGrayscaleImage = () => <Image src={emptyStateGrayscale} />;
export const EmptyStateGrayscale2Image = () => <Image src={emptyStateGrayscale2} />;
export const EmptyStateNotFoundImage = () => <Image src={emptyStateNotFound} />;
export const ErrorStateImage = () => <Image src={errorStateImage} />;
export const ErrorState401Image = () => <Image src={errorState401Image} />;
export const ErrorState404Image = () => <Image src={errorState404Image} />;
export const ErrorState404GrayscaleImage = () => <Image src={errorState404GrayscaleImage} />;
export const ErrorState500Image = () => <Image src={errorState500Image} />;
export const DashboardImage = () => <Image src={dashboardImage} />;
export const ErrorStateNetworkImage = () => <Image src={errorStateNetworkImage} />;
export const NoResultSearch = () => <Image src={noResultSearch} />;
export const SearchEmptyState = () => <Image src={searchEmptyState} />;
export const ConfirmationState = () => <Image src={confirmationState} />;
export const ConfirmationState2 = () => <Image src={confirmationState2} />;
export const ProcessingState = () => <Image src={processingState} />;
export const EmptyStateSelloutImage = () => <Image src={emptyStateSellout} />;
